module.exports = __webpack_public_path__ + "fonts/display-medium.53ea991c.woff2";